module.exports = "/_next/static/images/57f36214fe3ea77311a1ee8295d4de00-credit-card.svg";